import * as ActionType from "./shorts.type";

const initialState = {
  shortsData: [],
  totalShorts: null,
  loading: true,
  hashtag: [],
  totalHashtag: null,
  hashtagData: [],
  featureHashtags: [],
};

export const shortsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.UPDATEFEATURE:
      let { featureIds } = action.payload;
      let { feature } = action.payload;
      return {
        ...state,
        shortsData: state.shortsData.map((item) => {
          if (featureIds.includes(item._id)) {
            return {
              ...item,
              feature: feature, // Set feature to the provided boolean value
            };
          } else {
            return {
              ...item,
              feature: item.feature !== undefined ? item.feature : false, // Keep existing or set to false if not in featureIds
            };
          }
        }),
      };
    case ActionType.GETFEATURETAGS:
      return {
        ...state,
        featureHashtags: action.payload.data.featureHashtags,
      };
    case ActionType.DELETEHASHTAG:
      return {
        ...state,
        hashtagData: state.hashtagData.filter(
          (data) => !action.payload.id.includes(data._id)
        ),
      };
    case ActionType.HOMEHASHTAG:
      return {
        ...state,
        totalHashtag: action.payload.totalHashtag,
        hashtagData: action.payload.hashtagData,
      };

    case ActionType.HASHTAG:
      return {
        ...state,
        hashtag: action.payload.data,
      };
    case ActionType.LOADING:
      return {
        ...state,
        loading: action.payload.loading,
      };
    case ActionType.GET_SHORTS:
      return {
        ...state,
        shortsData: action.payload.shortsData,
        totalShorts: action.payload.totalShorts,
      };

    case ActionType.IMPORT_SHORT:
      const importedVideo = action.payload.data;

      const newVideoData = {
        ...importedVideo,
        fullName: importedVideo.userId.fullName,
        uniqueId: importedVideo.userId.uniqueId,
      };

      const updatedShortsData = [newVideoData, ...state.shortsData];

      return {
        ...state,
        shortsData: updatedShortsData,
        totalShorts: action.payload.totalNumber,
      };

    case ActionType.EDIT_SHORT:
      const updatedVideoData = state.shortsData.map((item) => {
        if (item._id === action.payload.data._id) {
          return {
            ...action.payload.data,
            title: action.payload.data.title,
            fullName: action.payload.fullName,
            userId: action.payload.data?.userId?._id,
            image: action.payload.data.userId.image,
            uniqueId: action.payload.data?.uniqueVideoId,
          };
        }
        return item;
      });
      console.log("updatedVideoData", action.payload.data);
      console.log("updatedVideoData", updatedVideoData);
      return {
        ...state,
        shortsData: updatedVideoData,
      };
    case ActionType.DELETE_SHORT:
      return {
        ...state,
        shortsData: state.shortsData.filter(
          (data) => !action.payload.id.includes(data._id)
        ),
      };
    default:
      return state;
  }
};
